export const GOLPOINTS_CONTAINER_IMG_DESKTOP = '225px';
export const GOLPOINTS_CONTAINER_IMG_MOBILE = '151px';
